import type { i18n as I18n } from 'i18next';
import type { Auth } from 'firebase/auth';

/**
 * Keep Firebase Auth's language in step with the site's, so the emails Firebase
 * sends (password reset, address verification) arrive in the language the person
 * is reading the site in rather than the console template's default.
 */
export function syncAuthLanguage(i18n: I18n, auth: Auth) {
  const apply = (lng?: string) => {
    auth.languageCode = (lng || 'en').split('-')[0];
  };
  apply(i18n.resolvedLanguage);
  i18n.on('languageChanged', apply);
}
